module.exports = __webpack_public_path__ + "img/USDT.e5ab33fb.svg";